/**
 * The gate rule metrics as select options — the verdict, scaling and
 * stop-loss condition rows pick from these (shared `GATE_METRICS`).
 * For Media Devoted | Created By Ciro Autiero
 */
import { GATE_METRICS, type GateMetricId } from '@trafficpulse/shared';

export interface GateMetricOption {
  value: GateMetricId;
  label: string;
  group: 'tracker' | 'smswiser' | 'both';
  format: 'int' | 'money' | 'percent' | 'ratio';
}

export const GATE_METRIC_OPTIONS: GateMetricOption[] = GATE_METRICS.map((metric) => ({
  value: metric.id,
  label: metric.label,
  group: metric.group,
  format: metric.format,
}));
